export default class Header {
  constructor() {
    this.dom = {
      $header: $('#header'),
    }
  }

  init() {
    if (this.dom.$header.length) {
      this.setUpPin()
    }
  }

  setUpPin() {
    const menuItem = '.menu-item'
    const isOpenChild = 'is-open-child'
    const dropdownMenu = '.dropdown-menu'

    let lastScrollTop = 100
    let initTime
    $(window).scroll(() => {
      const $header = $('#header')
      const st = $(window).scrollTop()
      const heightHeader = $header.innerHeight()
      if (st < heightHeader || window.innerWidth < 1200) {
        return false
      }
      if (st >= lastScrollTop) {
        $header.addClass('move-down')
        $(menuItem).removeClass(isOpenChild)
        $(menuItem).find(dropdownMenu).addClass('hidden')
        $('.dropdown-sub-menu').stop().fadeOut()
      } else {
        clearTimeout(initTime)
        $header.removeClass('move-down')
      }
      lastScrollTop = st
      return true
    })
  }
}
new Header().init()
